import React from 'react'
import { Grid, Typography } from '../../../mui/Core/index'

export function PageNotFoundError() {
  return (
    <Grid container sx={{ mt: 50 }} direction='column' alignItems='center'>
      <Grid>
        <Typography variant='h3'>Error 404: Not Found</Typography>
        <Typography variant='errorMessage' sx={{ mt: 3 }}>
          The page you are trying to access does not exist.
        </Typography>
        <Typography variant='errorMessage'>Please try navigating to a different page.</Typography>
      </Grid>
    </Grid>
  )
}
